const fs = require("fs");
const nconf = require("nconf");
const Immutable = require("immutable");
const iconsPreval = require("./preval/icons.preval");
const { writeFile } = require("./helpers/outputHelper");

const icons = Immutable.fromJS(iconsPreval || {});
const iconData = JSON.stringify(icons);

nconf.argv();
const generateToFile = nconf.get("to-file");

const writeIconFile = (data) => {
  writeFile(data, "icons.json");
};

const generate = (data, toFile) => {
  if (!toFile) {
    console.log(data);
  }
  return toFile ? writeIconFile(data) : data;
}

// Export the function writeFile as default
module.exports = generate(iconData, generateToFile);